import { render, staticRenderFns } from "./FinishingTable.vue?vue&type=template&id=5e361e5b"
import script from "./FinishingTable.vue?vue&type=script&lang=js"
export * from "./FinishingTable.vue?vue&type=script&lang=js"
import "./FinishingTable.vue?vue&type=style&index=0&id=5e361e5b&prod&lang=scss"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports